import PropTypes from 'prop-types';
import React from 'react';
import InfiniteList from '../infinite-list';
import { HorizontalSeparator } from '../../components/separator';
import MemberListItem from '../member-list-item';

const THRESHOLD = 400;

const MemberList = ({ members }) =>
  <InfiniteList
    length={members.length}
    itemRenderer={idx =>
      <div className="forum-card-background-color" key={members[idx]._id}>
        <MemberListItem member={members[idx]}/>
        <HorizontalSeparator/>
      </div>}
    threshold={THRESHOLD}
  />;

MemberList.propTypes = {
  members: PropTypes.array.isRequired,
};

export default MemberList;



// WEBPACK FOOTER //
// ./app/components/member-list/member-list-mobile.js